import { render, staticRenderFns } from "./PsychologyHistorialTable.vue?vue&type=template&id=ba99b168&"
import script from "./PsychologyHistorialTable.vue?vue&type=script&lang=js&"
export * from "./PsychologyHistorialTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports